/* eslint-disable no-case-declarations */
import {
  IActiveCollection,
  IGetFiltersResult,
  ISearchProviderConfig,
} from '../../../types';
import mapFilters from '../helpers/mappers/mapFilters';

import { elevate, localStorageBackedSession } from '@apptus/esales-api';
import { getMarket, getLocale, getTouchpoint, getViewId, getVoyadoSession, hasCookieConsent } from '../helpers/voyadoHelpers';
import { elevateFetchShim } from '../helpers/elevateFetchShim';

const GetFilters = async (activeCollection: IActiveCollection, searchTerm: string|null, config: ISearchProviderConfig): Promise<IGetFiltersResult> => {
  elevateFetchShim();

  const pageTemplate = window['theme'].template;

  const mappedResponse: IGetFiltersResult = {
    filters: []
  }

  try {

    // Step 3: Ensure session is properly initialized and keys are generated
    // Use ephemeral session (random per request) if cookies declined, otherwise persisted session
    const session = getVoyadoSession(localStorageBackedSession);
    const sessionKeys = session();

    const hasConsent = hasCookieConsent();

    if (!sessionKeys.customerKey || !sessionKeys.sessionKey) {
      throw new Error('Session keys are not properly initialized');
    }

    const api = elevate({
      clusterId: config.clusterId,
      market: getMarket(),
      locale: getLocale(),
      touchpoint: getTouchpoint(),
      session: session
    });

    let res

    switch (pageTemplate) {
      case 'search':

        const searchParams: any = {
          viewId: getViewId(),
          q: searchTerm ?? new URLSearchParams(window.location.search).get('q')
        };
        // Only include notify when cookies are declined (notify: false)
        if (!hasConsent) {
          searchParams.notify = false;
        }
        res = await api.query.searchPage(searchParams);

        break;
      case 'collection':


        const landingParams: any = {
          viewId: getViewId(),
          pageReference: activeCollection && activeCollection.handle ? `/${activeCollection.handle}` : '/'
        };
        // Only include notify when cookies are declined (notify: false)
        if (!hasConsent) {
          landingParams.notify = false;
        }
        res = await api.query.landingPage(
          landingParams,
          {
            primaryList: {
              include: true
            }
          }
        );

        break;
      default:
        throw new Error('Error when getting Filter results');
    }

    // Extract autoCorrect from the GET request response (only available in GET, not POST with contentLists)
    const { autoCorrect } = res as any;
    mappedResponse.filters = mapFilters(res.primaryList.facets);

    // Extract and return autoCorrect data if present
    if (autoCorrect) {
      mappedResponse.autoCorrectedQuery = autoCorrect.q ?? null;
      mappedResponse.autoCorrectOriginalTotalHits = autoCorrect.originalTotalHits ?? null;
    }

    return mappedResponse;
  } catch (e) {
    throw new Error(`Error when getting Filter results: ${e}`);
  }
};

export default GetFilters